var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"w-subtitle-1 section-title mt-3 mb-2",class:{'info--text text--darken-1': !_vm.no_color},attrs:{"data-test-id":"section-title"}},'div',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }